module.exports = __webpack_public_path__ + "img/petto-di-pollo.57788f5e.png";